export default function HealthClasses() {
  return [
    { label: "Best", value: "best" },
    { label: "Better", value: "better" },
    { label: "Good", value: "good" },
  ];
}
